import { amendTradeSelectorsFactory } from 'state/secondaryMarket/shared/amend/amend.selector';

export const cpOrderAmendSelectors = amendTradeSelectorsFactory('cpOrder');
